// extracted by mini-css-extract-plugin
export default {"containter":"first_containter__wKy5L","icon":"first_icon__CbwAh"};